import { View } from 'backbone.marionette';
import template from './index.jst';
import { Model } from 'backbone';
import Radio from "backbone.radio";

const matchUpChannel = Radio.channel('match_up');


export class MatchUpHeaderSelect extends View {
	get template() {
		return template;
	}

	get className() {
		return 'matchup-page-header';
	}

	ui() {
		return {
			select: '.js-change-fixture'
		}
	}

	events() {
		return {
			'change @ui.select': 'onFixtureChanged'
		}
	}

	initialize() {
		this.model = new Model({
			avatar: null,
			name: '',
			fixture_item: []
		});
	}

	init({ avatar, name, fixture_item }) {

		this.model.set({ avatar, name, fixture_item });

		this.render();
	}

	onFixtureChanged() {
		const index = this.getUI('select').val();

		matchUpChannel.trigger('fixture:item:changed', index);
	}
}

export default MatchUpHeaderSelect;